<template lang="pug">
section.v-half-banner.half-banner(v-if="baner"
		:style="{'background': baner.background ? baner.background : baner.backgroundColor}"
		:class="{'half-banner--blackout': baner.blackout, 'half-banner--right': baner.view === 'right'}")
	.half-banner__container.container
		.half-banner__wrap
			.half-banner__left
				template(v-if="baner.image")
					.half-banner__image-wrap
						img.half-banner__image(:src="baner.image" alt="" loading="lazy")
				template(v-else-if="baner.video")
					.half-banner__video-wrap
						v-video.half-banner__video(:type="baner.video.type"
								:poster="baner.video.poster"
								:src="baner.video.src"
								:autoplay="baner.video.autoplay",
								:loop="baner.video.loop"
								:origin="baner.video.origin")
			.half-banner__right
				template(v-if="baner.content")
					.half-banner__content.text-guide(v-html="baner.content")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			baner: null
		};
	},

	methods: {
		dataSet(data) {
			this.baner = data;
		}
	}
};
</script>